import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {PrivateProfileModel} from '../common/PrivateProfile/PrivateProfile.model';
import type {CourseModel} from '../Course/Course.model';
import type {SubtenantModel} from '../Subtenant/Subtenant.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'MembershipModel';

export class MembershipModel extends BaseModel {
  cardId: Nullable<string>;
  course: Nullable<CourseModel>;
  privateProfile: PrivateProfileModel;
  status: MembershipModel.Status;
  subtenant: Nullable<SubtenantModel>;

  constructor(props: MembershipModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<MembershipModel, MembershipModel.Props>(
        props,
      ),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace MembershipModel {
  export type Props = BaseModel.ModelToProps<MembershipModel>;

  export type Status =
    | 'accepted'
    | 'active'
    | 'archived'
    | 'declined'
    | 'frozen'
    | 'proposed'
    | 'requested';
}
